<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs2 md2>
        <v-btn color="primary" dark text @click="showDialog(true)"
          >新增訂單</v-btn
        >
      </v-flex>
      <v-flex xs2 md2>
        <v-btn color="green" dark text @click="exportData">匯出出貨單</v-btn>
      </v-flex>
    </v-layout>

    <v-layout  mt-2>
      <v-flex xs5 sm5 md5>
        <date-picker :date.sync="search.startDate" />
      </v-flex>
      <v-flex xs5 sm5 md5>
        <date-picker :date.sync="search.endDate" />
      </v-flex>
    </v-layout>
    <v-layout xs12>
      <!-- <v-flex xs5 md3>
        <v-select
          :items="typeKeys"
          item-text="text"
          item-value="key"
          v-model="typeStatus"
          label="篩選月份"
        ></v-select>
      </v-flex> -->
      <v-flex ml-2 md5 xs8>
        <v-text-field
          v-model="search.keyword"
          :label="`搜尋出貨單`"
          :placeholder="search.placeholder"
          @keyup.enter="searchEvent"
        ></v-text-field>
      </v-flex>
      <v-flex md4 xs4>
        <v-btn color="success" @click="searchEvent">搜尋</v-btn>
        <v-btn color="warning" @click="reset">重置</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <table-view
        :columnKeys="columnKeys"
        :items="items"
        :loading="loading"
        :total-items="totalItems"
        @cellEvent="cellEvent"
        @changePage="changePage"
        @handleLoadData="reset"
      >
      </table-view>
    </v-layout>

    <delivery-dialog
      :visible="editDialog.visible"
      :title="editDialog.title"
      :item="editDialog.item"
      :isNew="editDialog.isNew"
      @cancelEvent="editDialog.cancel"
      @confirmEvent="editDialog.confirm"
    ></delivery-dialog>

    <v-dialog v-model="deliveryViewDialog.visible" :max-width="'50%'">
      <v-card>
        <v-card-text>
          <v-layout xs12>
            <v-flex>
              <v-btn color="primary" dark text @click="openDeliveryView">檢視出貨單</v-btn>
            </v-flex>
<!--            <v-flex>-->
<!--              <v-btn class="primary" dark text>出貨單轉圖片</v-btn>-->
<!--            </v-flex>-->
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark text @click="deliveryViewDialog.confirm">關閉</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--彈出視窗-->
    <alert-view
      :visible="messageDialog.visible"
      :title="messageDialog.title"
      :content="messageDialog.text"
      :isHtmlContent="true"
      :showCancel="messageDialog.showCancelButton"
      @cancelEvent="messageDialog.cancel"
      @confirmEvent="messageDialog.confirm"
    ></alert-view>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MobileDetect from "mobile-detect";

import AlertView from "@/components/AlertView";
import TableView from "@/components/TableView";
import DatePicker from "@/components/DatePicker";
import DeliveryDialog from "@/components/DeliveryDialog";
import DeliveryOrderModel from "../../models/DeliveryOrderModel";
import { exportFileToBlobUrl } from "../utils/tool";
import common from '../../mixins/common'
import { fetchStoreList } from '@/store/actions';
import DeliveryNoteView from '@/components/DeliveryNoteView';
const md = new MobileDetect(window.navigator.userAgent);

export default {
  name: "DeliveryNoteList",
  components: {
    DeliveryNoteView,
    AlertView,
    TableView,
    DatePicker,
    DeliveryDialog,
  },
   mixins:[common],
  data() {
    return {
      loading: false,
      pageIndex: 1,
      limit: 5,
      totalItems: 0,
      typeStatus: 0,
      search: {
        keyword: "",
        placeholder: "搜尋單號、店家、業務",
        startDate: "2021-01-01",
        endDate: "2121-01-01",
        searchKey: "",
      },
      items: [],
      messageDialog: {
        title: "",
        text: "",
        visible: false,
        showCancelButton: false,
        confirm: () => {},
        cancel: () => {},
      },
      editDialog: {
        title: "",
        visible: false,
        item: null,
        isNew: false,
        confirm: () => {},
        cancel: () => {},
      },
      deliveryViewDialog: {
        title: "",
        visible: false,
        item: null,
        isNew: false,
        confirm: () => {},
        cancel: () => {},
      },
    };
  },
  created() {
    this.fetchAgentList().then((res) => {});
    this.fetchStoreList().then((res) => {});
    this.setDefualtDate()
    this.loadData();

  },
  computed: {
    ...mapGetters(["getUserInfo", "getAgentList", 'getStoreList']),
    columnKeys() {
      const list = [
        {
          value: "show",
          text: "檢視",
          sortable: false,
          required: false,
          color: "primary",
          isEvent: true,
        },
        {
          value: "edit",
          text: "操作",
          sortable: false,
          required: false,
          color: "primary",
          isEvent: true,
        },
        {
          value: "createdDate",
          text: "建立時間",
          sortable: true,
          required: false,
        },
        {
          value: "displayId",
          text: "出貨單號",
          sortable: true,
          required: false,
        },
        { value: "productCount", text: "商品數量", sortable: true, required: false },
        { value: "storeId", text: "店家名稱", sortable: true, required: false, isSelect: true, options: this.findStoreList},
        // { value: "phone", text: "店家電話", sortable: true, required: false, isSelect: true, options: this.findStoreInfoList },
        { value: "deliveryStatus", text: "出貨單狀態",  options: this.deliveryStatusList,
          isSelect: true, sortable: true, required: false },
        { value: "introducerId", text: "介紹人", sortable: true, required: false, isSelect:true, options: this.findAgentList },
        { value: "introducerBonus", text: "介紹人佣金", sortable: true, required: false },
        { value: "city", text: "縣市", sortable: true, required: false },
        { value: "street", text: "鄉鎮區", sortable: true, required: false },
        { value: "address", text: "地址", sortable: true, required: false },

        { value: "transportPrice", text: "運費", sortable: true, required: false },
        { value: "discount", text: "折扣", sortable: true, required: false },
        { value: "price", text: "總金額", sortable: true, required: false },
        { value: "realPrice", text: "實際售價", sortable: true, required: false },
        { value: "agentId", text: "業務姓名", sortable: true, required: false, isSelect:true, options: this.findAgentList},
        { value: "agentBonus", text: "業務佣金", sortable: true, required: false },
        { value: "paymentType", text: "付款方式",  options: this.paymentList,
          isSelect: true, sortable: true, required: false  },
        { value: "paymentStatus", text: "付款狀態",  options: this.paymentStatusList,
          isSelect: true, sortable: true, required: false  },
        { value: "paymentDate", text: "入帳日期", sortable: true, required: false },
        { value: "comment", text: "備註", sortable: true, required: false },
      ];
      return list;
    },
    getTotalItems() {
      return this.totalItems;
    },
    typeKeys() {
      let list = [];
      for (let i = 1; i <= 12; i++) {
        let month = i > 9 ? `${i}` : `0${i}`;
        list.push({ key: i, text: `${month}` });
      }
      return list;
    },
    findAgentList(){
      const list = [];
      for (let agent of this.getAgentList){
        list.push({
          key: agent.agentId,
          text: agent.displayName
        })
      }
      return list;
    },
    findStoreList(){
      const list = [];
      for (let store of this.getStoreList){
        list.push({
          key: store.storeId,
          text: store.name
        })
      }
      return list;
    },
  },
  methods: {
    ...mapActions(["storeList", "orderList", "orderInfo",'fetchAgentList','fetchStoreList']),
    setDefualtDate() {
      let todayDate = new Date();
      todayDate.setMonth(todayDate.getMonth() - 1);
      let currentDate = todayDate.toISOString().substr(0, 10);
      const [thisYear, thisMonth, thisDay] = currentDate.split("-");
      this.search.startDate = `${thisYear}-${thisMonth}-01`;

      let futureDate = new Date();
      // 将当前月份加1，下移到下个月
      futureDate.setMonth(futureDate.getMonth() + 1);
      // 再获取天数即取上个月的最后一天的天数
      futureDate.setDate(0);
      let days = futureDate.getDate();

      let endDate = futureDate.toISOString().substr(0, 10);
      const [futureYear, futureMonth, futureDay] = endDate.split("-");

      this.search.endDate = `${futureYear}-${futureMonth}-${days}`;
    },
    setMonth() {

    },
    changePage(page) {
      // 改變頁數 or 每頁筆數
      this.pageIndex = page.page;
      this.limit = page.rowsPerPage;
      this.loadData();
    },
    changeTypeStatus() {
      this.loadData();
    },
    async exportData() {
      let results = await this.dataService(1, 10000);

      let list = results.data.data.list
      const columns = [
        { name: "出貨單號", key: "displayId" },
        { name: "商品數量", key: "productCount" },
        { name: "出貨時間", key: "deliveryDate" },
        { name: "店家名稱", key: "storeId" },
        { name: "縣市", key: "city" },
        { name: "區域", key: "street" },
        { name: "地址", key: "address" },
        { name: "送貨人", key: "deliveryStaff" },
        { name: "運費", key: "transportPrice" },
        { name: "介紹人", key: "introducerId" },
        { name: "介紹人佣金", key: "introducerBonus" },
        { name: "業務", key: "agentId" },
        { name: "業務佣金", key: "agentBonus" },
        { name: "出貨單狀態", key: "deliveryStatus" },
        { name: "付款狀態", key: "paymentStatus" },
        { name: "運送狀態", key: "deliveryStatus" },
        { name: "總金額", key: "price" },
        { name: "實際售價", key: "realPrice" },
        { name: "備註", key: "comment" },
      ];
      exportFileToBlobUrl("匯出出貨單", columns, list);
    },
    async loadData() {
      let results = await this.dataService();
      this.items = results.data.data.list
    },
    async dataService(pageIndex = this.pageIndex, limit = this.limit) {
      this.loading = true;
      const data = {
        startDate: "2021-06-01 00:00:00",
        endDate: "2021-08-01 23:59:59",
        pageIndex: pageIndex,
        limit: limit,
        searchQuery: []
      }
      console.log(JSON.stringify(data))
      let result = await this.orderList(data)
      this.loading = false;
      return result;
    },
    cellEvent(props) {
      // cell 按鈕事件 (用Key判斷是點選哪一個
      console.log(`cellEvent ${JSON.stringify(props)}`);
      if (props.key === 'edit') {
        this.showDialog(false, props.item);
      } else if (props.key === 'show') {
        this.showDeliveryViewDialog(props.item);
      }
    },
    showDialog(isNew, item = new DeliveryOrderModel()) {
      this.editDialog.title = isNew ? "新增" : "編輯";
      this.editDialog.visible = true;
      this.editDialog.item = item;
      this.editDialog.isNew = isNew;
      console.log(`item ${JSON.stringify(this.editDialog.item)}`);
      const self = this;
      (this.editDialog.confirm = () => {
        self.editDialog.visible = false;
        self.loadData();
      }),
        (this.editDialog.cancel = () => {
          self.editDialog.visible = false;
        });
    },
    showDeliveryViewDialog(item = new DeliveryOrderModel()) {
      this.deliveryViewDialog.visible = true;
      this.deliveryViewDialog.item = item;
      const self = this;
      (this.deliveryViewDialog.confirm = () => {
        self.deliveryViewDialog.visible = false;
      }),
        (this.deliveryViewDialog.cancel = () => {
          self.deliveryViewDialog.visible = false;
        });
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.text = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
    searchEvent() {
      this.loadData();
    },
    reset() {
      this.search.keyword = "";
      this.loadData();
    },
    openDeliveryView(){
      let routeData = this.$router.resolve({name: 'DeliveryNoteView', query: { deliveryId: this.deliveryViewDialog.item.deliveryId }});
      window.open(routeData.href, '_blank');
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/web/DeliveryNoteList.vue